module.exports = __webpack_public_path__ + "images/emoji/fire.e15b3ffa29cef592c3e3.png";